import classes from "./RightPanelContent.module.css";
import BoxTitle from "../../box/title/BoxTitle";
import BoxEntity from "../../box/entity/BoxEntity";
import { useEffect, useState, useRef, useContext } from "react";
import { useStore } from "../../../hooks/store";
import parse from "html-react-parser";
import CustomSlider from "../../customSlider/CustomSlider";
import { SRLWrapper } from "simple-react-lightbox";
import SimpleReactLightbox from "simple-react-lightbox";
import { Fragment } from "react";
import { useLocation } from "react-router-dom";

import ViewModal from "../../utils/ViewModal";
import "../../utils/ViewModal.css";
import { SensorIdContext } from "../../../hooks/SensorIdProvider";
import { feedPublicParking } from "../../../services/metrics";
import { publicParkingUrl } from "../../../../SMARTCITY/hardCodeData/DATA";
import { useAllContexts } from "../../../hooks/useAllContexts";
import styled from "styled-components";
import SmallCharts from "../../charts/SmallCharts/SmallCharts";
import { getElectricLampHistory } from "../../../services/services";

const options = {
  settings: {
    overlayColor: "rgb(104, 104, 104)",
    autoplaySpeed: 1500,
    transitionSpeed: 900,
  },
  buttons: {
    backgroundColor: "black",
    iconColor: "white",
  },
  caption: {
    captionColor: "white",
    captionFontFamily: "Raleway, sans-serif",
    captionFontWeight: "300",
    captionTextTransform: "uppercase",
  },
  progressBar: {
    backgroundColor: "#F2F2F2",
    fillColor: "#000000",
    height: "3px",
    showProgressBar: true,
  },
};

const RightPanelContent = ({ close }) => {
  const [data, setData] = useState({ metrics: [], title: "" });
  const [loadingData, setLoadingData] = useState(false);

  const [historicData, setHistoricData] = useState(null);
  const [loadingHistoricData, setLoadingHistoricData] = useState(false);

  const typeStyleVertical = useRef(null);
  const colorIconTitle = useRef(null);
  const iconTitleRef = useRef(null);

  const { variables, publicParking } = useAllContexts();

  const { getSelectedItem } = variables;

  const { search } = useLocation();
  const typeId = new URLSearchParams(search).get("typeId");

  useEffect(() => {
    setHistoricData(null);
    if (getSelectedItem) {
      console.log("selected item:", getSelectedItem);
    }
    // if (sensorId.get) {
    //   console.log(sensorId.get);
    // }
  }, [getSelectedItem]);

  // useEffect(() => {
  //   handlePublicParkingData();
  //   // setPublicParkingData(tempPublicParkingData);

  //   if (sensorId.get) {
  //     const currTypeURL = new URLSearchParams(search).get("typeId");
  //     const currSensorURL = sensorId.get.toString();

  //     const tempTypeIdActive = state.types.filter(
  //       (item) => item.id === currTypeURL
  //     );

  //     if (tempTypeIdActive.length > 0 && state.sensors.length > 0) {
  //       iconTitleRef.current = tempTypeIdActive[0].icon;
  //       colorIconTitle.current = {
  //         backgroundColor: tempTypeIdActive[0].color,
  //         minWidth: "50px",
  //         maxWidth: "50px",
  //         minHeight: "50px",
  //         maxHeight: "50px",
  //         display: "flex",
  //         alignItems: "center",
  //         justifyContent: "center",
  //         borderRadius: "12px",
  //       };

  //       setLoadingData(true);

  //       if (currSensorURL) {
  //         const sensor = state.sensors.filter(
  //           (item) => item.id?.toString() === currSensorURL
  //         );

  //         if (sensor.length > 0) {
  //           if (sensor[0].typeId.toString() === "7") {
  //             setData({
  //               historic: {
  //                 category: sensor[0].categoryName,
  //                 image: sensor[0].thumbnail,
  //                 content: sensor[0].content,
  //                 images: sensor[0].images,
  //                 // images: [
  //                 //   "https://alexandroupoli.repository.gr/files/asset/b2d3f6e7dc5dd2435bdb3f21127ecf60221e71b8.jpg",
  //                 //   state.sensors[i].thumbnail,
  //                 // ],
  //               },
  //               title: sensor[0].title,
  //             });
  //             typeStyleVertical.current = "POIS";
  //           } else if (typeId === "36") {
  //             setData(
  //               publicParkingData?.filter(
  //                 (parkingGroup) => parkingGroup.mysensor_id === sensorId.get
  //               )
  //             );
  //           } else {
  //             // console.log(
  //             //   sensor[0].metrics,
  //             //   sensor[0].metrics.includes("Συντεταγμένες κάδου")
  //             // );
  //             let place = sensor[0].metrics.filter(
  //               (item) => item.content === "Συντεταγμένες κάδου"
  //             )[0];

  //             if (place) {
  //               const cords = place.value.split(" ");
  //               // console.log(cords);
  //               fetch(
  //                 `https://nominatim.openstreetmap.org/reverse?format=json&lat=${cords[0]}&lon=${cords[1]}&accept-language=el`
  //               )
  //                 .then((response) => response.json())
  //                 .then((data) => {
  //                   // console.log(data);

  //                   const dataMetrics = sensor[0].metrics.filter(
  //                     (item) =>
  //                       item.content !== "Συντεταγμένες κάδου" &&
  //                       item.content !== "Τάση μπαταρίας"
  //                   );
  //                   const tempLocation = {
  //                     content: "Περιοχή κάδου",
  //                     value: data.address.village
  //                       ? data.address.village
  //                       : data.address.town,
  //                   };
  //                   dataMetrics.push(tempLocation);
  //                   dataMetrics.push({
  //                     content: "Τύπος κάδου",
  //                     value: "Μπλε ανακύκλωσης 1100 lt",
  //                   });

  //                   setData({
  //                     metrics: dataMetrics,
  //                     title: sensor[0].title,
  //                   });
  //                   typeStyleVertical.current = "Metrics";
  //                 })
  //                 .catch((error) => console.warn(error));
  //             } else {
  //               setData({
  //                 metrics: sensor[0].metrics,
  //                 title: sensor[0].title,
  //               });
  //               typeStyleVertical.current = "Metrics";
  //             }
  //           }
  //         }
  //       } else {
  //         setData({ metrics: [], title: "" });
  //       }
  //     }
  //   }
  // }, [
  //   search,
  //   state.types,
  //   state.sensors,
  //   sensorId.get,
  //   publicParkingData,
  //   typeId,
  // ]);

  // useEffect(() => {
  //   if (data.title !== "") {
  //     setLoadingData(false);
  //   }
  // }, [data]);

  // const Metrics =
  //   data.metrics &&
  //   data.metrics
  //     .filter((item) => item.value)
  //     .map((item, index) => (
  //       <BoxEntity
  //         key={index}
  //         icon={item.icon_large}
  //         content={item.content}
  //         value={item.value}
  //         className={classes.gradient_border}
  //         styleValue={{ fontWeight: "400" }}
  //       />
  //     ));

  // const POIS = data.historic && (
  //   <Fragment>
  //     <SimpleReactLightbox>
  //       <SRLWrapper options={options}>
  //         {data.historic.image && (
  //           <img
  //             src={data.historic.image}
  //             alt="thumbnail"
  //             width="100%"
  //             style={{ cursor: "pointer" }}
  //           />
  //         )}
  //       </SRLWrapper>
  //     </SimpleReactLightbox>

  //     {data.historic.category && (
  //       <p style={{ fontSize: "14px" }}>
  //         Κατηγορία: <i>{data.historic.category}</i>
  //       </p>
  //     )}
  //     {data.historic.content && (
  //       <div style={{ marginTop: "20px", textAlign: "justify" }}>
  //         {parse(data.historic.content)}
  //       </div>
  //     )}

  //     {data.historic.images.length > 0 && (
  //       <div className={classes.slider_placeholder}>
  //         <p className={classes.more_photos_descr}>
  //           <i>Επιπλέον φωτογραφικό υλικό:</i>
  //         </p>
  //         <SimpleReactLightbox>
  //           <SRLWrapper options={options}>
  //             <CustomSlider
  //               settings={{
  //                 infinite: false,
  //               }}
  //             >
  //               {data.historic.images.map((image, index) => (
  //                 <div key={index} className={classes.image_placeholder}>
  //                   <img
  //                     src={image}
  //                     alt={data.title}
  //                     width="100%"
  //                     style={{ cursor: "pointer" }}
  //                   />
  //                 </div>
  //               ))}
  //             </CustomSlider>
  //           </SRLWrapper>
  //         </SimpleReactLightbox>
  //       </div>
  //     )}
  //   </Fragment>
  // );

  const renderHeaderTitle = () => {
    const item = getSelectedItem;
    switch (typeId) {
      case "1": {
        return item?.mysensor_name;
      }
      case "24": {
        return item?.LabelOnStreet;
      }
      case "37": {
        return item?.address;
      }
      default: {
        return item?.mysensor_name;
      }
    }
  };

  const renderHeaderIcon = () => {
    let iconName = "";
    switch (typeId) {
      case "1": {
        iconName = "im-icon-Globe";
        break;
      }
      case "2": {
        iconName = "im-icon-Business-Mens";
        break;
      }
      case "5": {
        iconName = "im-icon-Cloud-Sun";
        break;
      }
      case "6": {
        iconName = "im-icon-Drop";
        break;
      }
      case "30": {
        iconName = "im-icon-Battery-Charge";
        break;
      }
      case "24":
      case "36": {
        iconName = "im-icon-Car-2";
        break;
      }
      case "37": {
        iconName = "im-icon-Lamp";
        break;
      }
      default: {
        iconName = "";
        break;
      }
    }
    return (
      <i
        style={{ fontSize: "30px" }}
        className={`className="im im im ${iconName}`}
      ></i>
    );
  };

  const handleFetchHistoricData = async (lampId) => {
    setLoadingHistoricData(true);
    const response = await getElectricLampHistory({ lampId, date: null })
      .then((response) => response)
      .catch((error) => [])
      .finally(() => setLoadingHistoricData(false));
    const dataName = Object.keys(response.data);
    if (response.data?.[dataName].length > 0) {
      const formattedData = response.data?.[dataName].map((item) => {
        const splittedDateTime = item.date_insert.split(" ");
        const splittedDate = splittedDateTime[0].split("-");
        return {
          date_insert: `${splittedDateTime[0]}`,
          hour_insert: `${splittedDateTime[0].slice(0, 2)}`,
          datetime: `${splittedDate[0]}/${splittedDate[1]}/${splittedDate[2]} ${splittedDateTime[1]}`,
          val: `${item.status}`,
        };
      });

      setHistoricData(formattedData);
    } else {
      setHistoricData(null);
    }
  };

  const renderContent = () => {
    const item = getSelectedItem;
    switch (typeId) {
      case "1":
      case "5":
      case "6": {
        return (
          <>
            {item?.details?.map((detail, id) => {
              return (
                <>
                  <SectionItem key={detail.sensorvar_id}>
                    <ItemName>
                      <ItemIcon
                        src={`https://korydallos.smartiscity.gr/gallery/vars/Small/${detail.sensorvar_icon}`}
                      ></ItemIcon>
                      <ItemTitle>{detail.sensorvar_description}</ItemTitle>
                    </ItemName>

                    <ItemTitle>
                      {parseFloat(detail.measurement).toFixed(2)}
                    </ItemTitle>
                  </SectionItem>
                  <Divider />
                </>
              );
            })}
          </>
        );
      }
      case "2": {
        return (
          <>
            {item?.details?.map((detail, id) => {
              return (
                <>
                  <SectionItem key={detail.sensorvar_id}>
                    <ItemName>
                      <ItemIcon
                        src={`https://korydallos.smartiscity.gr/gallery/vars/Small/${detail.sensorvar_icon}`}
                      ></ItemIcon>
                      <ItemTitle>{detail.sensorvar_description}</ItemTitle>
                    </ItemName>

                    <ItemTitle>
                      {parseFloat(detail.wfTotal ?? detail.btTotal)}
                    </ItemTitle>
                  </SectionItem>
                  <Divider />
                </>
              );
            })}
          </>
        );
      }
      case "24": {
        return (
          <>
            <SectionItem>
              <span>Κατειλημμένη:</span>{" "}
              <span>{item?.IsOccupied ? "Ναι" : "Όχι"}</span>
            </SectionItem>
            <Divider />
            <SectionItem>
              <span>Κατειλημμένη από:</span>{" "}
              <span>{item?.IsOccupied ? item?.OccupiedFrom : "-"}</span>
            </SectionItem>
            <Divider />
            <SectionItem>
              <span>Τύπος:</span> <span>{item?.Type}</span>
            </SectionItem>
            <Divider />
          </>
        );
      }
      case "36": {
        const itemData = publicParking?.publicParkingData?.filter(
          (parking) => item?.ref_id === parking?.ref_id
        )[0];
        return (
          <>
            <SectionItem>
              <span>Ελεύθερες Θέσεις:</span>{" "}
              <span>{itemData?.available_slots}</span>
            </SectionItem>
            <Divider />
            <SectionItem>
              <span>Σύνολο Θέσεων:</span>{" "}
              <span>{`${itemData?.total_slots}`}</span>
            </SectionItem>
            <Divider />
          </>
        );
      }
      case "37": {
        const doubleDigitsNumber = (num) => (num < 10 ? `0${num}` : num);

        const handleDate = (epoch) => {
          const epochToDate = new Date(epoch * 1000);

          return `${doubleDigitsNumber(
            epochToDate.getDate()
          )}-${doubleDigitsNumber(epochToDate.getMonth())}-${doubleDigitsNumber(
            epochToDate.getFullYear()
          )}`;
        };
        return (
          <>
            <SectionItem>
              <span>Τύπος:</span> <span>{item?.lamp_type}</span>
            </SectionItem>
            <Divider />
            <SectionItem>
              <span>Είδος:</span> <span>{item?.kind}</span>
            </SectionItem>
            <Divider />
            <SectionItem>
              <span>Ισχύς:</span> <span>{item?.power}</span>
            </SectionItem>
            <Divider />
            <SectionItem>
              <span>Τελευταία Ενημέρωση:</span>{" "}
              <span>{handleDate(item?.last_update)}</span>
            </SectionItem>
            <Divider />
            <HistoryButton
              onClick={() => {
                handleFetchHistoricData(item?.id);
                // TO DO fetch history data
              }}
            >
              Προβολή Ιστορικού
            </HistoryButton>
            {loadingHistoricData && (
              <LoadingText>Φόρτωση Δεδομένων...</LoadingText>
            )}
            {historicData && <SmallCharts details={historicData}></SmallCharts>}
          </>
        );
      }
      default: {
        return null;
      }
    }
  };

  return (
    <>
      <RightSideContent>
        <HeaderSection>
          <HeaderIcon>{renderHeaderIcon()}</HeaderIcon>
          <HeaderTitle>{renderHeaderTitle()}</HeaderTitle>
          <CloseRightSide
            onClick={() => {
              close();
              setHistoricData(null);
            }}
          >
            x
          </CloseRightSide>
        </HeaderSection>
        <HeaderDivider />
        <div
          style={{
            width: "100%",
            height: "80%",
            overflowY: "auto",
            scrollbarWidth: "thin",
            scrollbarColor: " darkgray gray",
          }}
        >
          {renderContent()}
        </div>
      </RightSideContent>
    </>
  );
};

export default RightPanelContent;

const Divider = styled.hr`
  width: 90%;
  height: 0px;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px solid #858484;
`;

const SectionItem = styled.div`
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  gap: 1px;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
`;

const HeaderSection = styled.div`
  // background-color: red;
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
`;

const HeaderIcon = styled.div`
  width: 50px;
  height: 50px;
  background-color: #cb6de9ff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
`;

const HeaderTitle = styled.div`
  width: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
`;

const HeaderDivider = styled.hr`
  width: 100%;
  height: 0px;
  border-bottom: 2px solid;
  border-image-source: linear-gradient(
    to left,
    rgba(255, 255, 255, 0) 5%,
    rgba(255, 255, 255, 0.8) 50%,
    rgba(255, 255, 255, 0) 95%
  );
  border-image-slice: 1;
`;

const RightSideContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  height: 100%;
`;

const ItemName = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

const ItemIcon = styled.img`
  width: 32px;
  height: 32px;
`;

const ItemTitle = styled.div``;

const CloseRightSide = styled.div`
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  width: 20px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HistoryButton = styled.div`
  color: #242424bc;
  background-color: #aaa;
  width: 180px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: 0 auto;
  transition: all 0.4s ease-in-out;

  &:hover {
    background-color: #f2f2f2d6;
    transition: all 0.4s ease-in-out;
    color: #282828ff;
  }
`;

const LoadingText = styled.div`
  width: 180px;
  margin: 10px auto;
`;
